import React from 'react';
import { TouchableOpacity, View, StyleSheet, Image } from 'react-native';
import BaseText from '../BaseText';
import RowView from '../RowView';
import { Color, CommonProperties } from '../../styles';
import { useTranslation } from 'react-i18next';
import { i18nNS, useComponentTKey } from '../../i18n';

export default function EasyCardUsedDetails({ data, onPress }) {
  const { t } = useTranslation(i18nNS.tripHub);
  const { tKey } = useComponentTKey('TripHubScreen');
  const items = data?.length > 0 && data;
  return (
    <>
      {items?.map((item, index) => (
        <TouchableOpacity
          key={index}
          onPress={() => {
            onPress(item);
          }}
        >
          <View style={styles.container}>
            <BaseText style={styles.text}>Card used</BaseText>
            <RowView style={styles.innerContainer}>
              <Image
                style={styles.cardSvg}
                source={require('../../assets/images/easycard-creditcard.png')}
              />
              <View>
                <BaseText style={styles.textColor}>{item?.NameOnCard}</BaseText>
                <BaseText
                  style={styles.textColor}
                >{`####-####-${item?.CreditCardLastFourDigit}`}</BaseText>
              </View>
            </RowView>
          </View>
        </TouchableOpacity>
      ))}
    </>
  );
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: Color.background,
    ...CommonProperties.p3,
  },
  innerContainer: {
    ...CommonProperties.centerItems,
    ...CommonProperties.mt2,
  },
  text: {
    color: Color.grayText,
    ...CommonProperties.small,
  },
  textColor: {
    fontSize: 12,
    color: Color.primary,
  },
  cardSvg: {
    width: 70,
    height: 40,
    marginRight: 12,
  },
});
